import { isPointInZone } from "../../helpers";
import { Point } from "../../Renderer/types";
import { CurrentAction, PageState, ResizeHandlerPosition, State } from "../state";

export interface MouseDownAction {
  ctrlKey: boolean;
  location: Point;
  resizeHandlerPosition: ResizeHandlerPosition | null;
  shiftKey: boolean;
  type: "MOUSE DOWN";
}

const mouseDownOnPage = (state: PageState, action: MouseDownAction): PageState => {
  if (state.activeZones.length === 1 && action.resizeHandlerPosition !== null) {
    switch (action.resizeHandlerPosition) {
      case ResizeHandlerPosition.BOTTOM:
        return {
          ...state,
          currentAction: CurrentAction.RESIZING_BOTTOM,
          firstDragEvent: true,
          previousMouseLocation: action.location,
        };
      case ResizeHandlerPosition.LEFT:
        return {
          ...state,
          currentAction: CurrentAction.RESIZING_LEFT,
          firstDragEvent: true,
          previousMouseLocation: action.location,
        };
      case ResizeHandlerPosition.RIGHT:
        return {
          ...state,
          currentAction: CurrentAction.RESIZING_RIGHT,
          firstDragEvent: true,
          previousMouseLocation: action.location,
        };
      case ResizeHandlerPosition.TOP:
        return {
          ...state,
          currentAction: CurrentAction.RESIZING_TOP,
          firstDragEvent: true,
          previousMouseLocation: action.location,
        };
    }
  }
  // check if we are clicking on a zone to move it
  const selectedZoneIndex = state.zones.findIndex(isPointInZone(action.location));
  if (selectedZoneIndex >= 0) {
    if (state.activeZones.indexOf(selectedZoneIndex) >= 0) {
      // if ctrl is pressed, deselect this zone
      if (action.ctrlKey) {
        const activeZones = state.activeZones.filter(z => z !== selectedZoneIndex);
        return {
          ...state,
          activeZones,
          currentAction: CurrentAction.HOVERING_ZONE,
          previousMouseLocation: action.location,
        };
      }
      return {
        ...state,
        currentAction: CurrentAction.MOVING,
        firstDragEvent: true,
        previousMouseLocation: action.location,
      };
    }
    if (action.ctrlKey || action.shiftKey) {
      return {
        ...state,
        activeZones: state.activeZones.concat([selectedZoneIndex]),
        currentAction: CurrentAction.MOVING,
        firstDragEvent: true,
        previousMouseLocation: action.location,
      };
    }
    return {
      ...state,
      activeZones: [selectedZoneIndex],
      currentAction: CurrentAction.MOVING,
      firstDragEvent: true,
      previousMouseLocation: action.location,
    };
  }
  return {
    ...state,
    activeZones: [],
    currentAction: CurrentAction.CREATING_ZONE,
    previousMouseLocation: action.location,
    selection: {
      endx: action.location.x,
      endy: action.location.y,
      startx: action.location.x,
      starty: action.location.y,
    },
  };
};

export const mouseDown = (state: State, action: MouseDownAction): State => {
  const updatedPage = mouseDownOnPage(state.pages[state.activePage], action);
  if (updatedPage === state.pages[state.activePage]) {
    return state;
  }
  let currentLabel = state.currentLabel;
  // check if the active zones changed
  if (
    updatedPage.activeZones !== state.pages[state.activePage].activeZones &&
    updatedPage.activeZones.length > 0
  ) {
    const uniqueLabels: { [key: string]: true } = {};
    for (const zone of updatedPage.activeZones) {
      uniqueLabels[updatedPage.zones[zone].label] = true;
    }
    if (Object.keys(uniqueLabels).length === 1) {
      currentLabel = Object.keys(uniqueLabels)[0];
    }
  }
  return {
    ...state,
    currentLabel,
    currentLabelGroup: "",
    pages: [
      ...state.pages.slice(0, state.activePage),
      updatedPage,
      ...state.pages.slice(state.activePage + 1),
    ],
  };
};
